import React, { useEffect, useState } from "react";
import { Col, Form, ProgressBar, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import _ from "lodash";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import {
  useAddServiceMutation,
  useUpdateServiceMutation,
} from "../../Data/services/serviceApi";
import { Controller, useForm } from "react-hook-form";
import DetailRow from "../CustomComponents/DetailRow";
import { GAME_TYPE } from "../../constants";
import UserAvatar from "../CustomComponents/UserAvatar";

const DetailGameModal = ({ handleEditModalClose, editData }) => {
  console.log(editData);

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer} style={{ maxWidth: "90%" }}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 text-black">More Details</p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Row className="text-black g-5">
              <Col sm={12} md={6}>
                <DetailRow title={"Game Name"} value={editData.name} />

                <DetailRow
                  title={"Type"}
                  value={editData.row === GAME_TYPE.SOLO ? "Solo" : "Team"}
                />

                <DetailRow title={"Progress"} value={editData.progress + "%"} />

                <DetailRow
                  title={"Completed"}
                  value={editData.is_completed ? "Yes" : "No"}
                />
                <DetailRow
                  title={"Attempted"}
                  value={editData.attempted_questions}
                />
                <hr className="w-100"></hr>
                <p className="text-center fw-bold">Winner Team</p>
                <DetailRow title={"Name"} value={editData.winner_team.name} />
                <DetailRow title={"Score"} value={editData.winner_team.score} />
              </Col>
              <Col sm={12} md={6}>
                <p className="text-center fw-bold">Game Categories</p>
                {editData.game_teams.map((gameTeam, index) => (
                  <div key={index}>
                    <DetailRow title={"Name"} value={gameTeam.name} />
                    <DetailRow title={"Score"} value={gameTeam.score} />
                  </div>
                ))}
                <hr className="w-100"></hr>
                <p className="text-center fw-bold">Game Teams</p>
                {editData.game_categories.map((gameCat, index) => (
                  <div key={index} className="my-2">
                    <UserAvatar
                      username={gameCat.category.name.en}
                      image_url={gameCat.category.image}
                    />
                  </div>
                ))}
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default DetailGameModal;
